import { z } from "zod/mini"

import { LinkContentSchema, LinkContentType } from "./link"

export const RepeatableContentType = "RepeatableContent" as const

export const RepeatableContentSchema = z.object({
	__TYPE__: z.literal(RepeatableContentType),
	type: z.literal("Link"),
	value: z.array(LinkContentSchema),
})

export type RepeatableContent = z.infer<typeof RepeatableContentSchema>

const RepeatableContentTypes = [LinkContentType]
type RepeatableContentType = (typeof RepeatableContentTypes)[number]
export function isRepeatableContentValue(content: {
	__TYPE__: string
}): content is { __TYPE__: RepeatableContentType } {
	return (RepeatableContentTypes as string[]).includes(content.__TYPE__)
}
